"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const child_process_1 = require("child_process");
const cli_core_1 = require("@/cli-core");
const cli_api_1 = require("@/cli-api");
const lang_1 = require("@/service/lang");
const commands_json_1 = __importDefault(require("@/config/commands.json"));
const CLIConfig = commands_json_1.default;
cli_core_1.CLI.loading.start(lang_1.Lang.CORE_STRTUP_READY);
// 判断是否为 VS Code 本地调试环境
const isDebug = process.env.DEBUG_ENV === 'true';
const globalNpmRoot = cli_core_1.ChildProcess.runCmdSync('npm root -g');
/**
 * 调试模式，根目录指向当前项目根目录
 * 生产环境：根目录指向指向NPM全局包目录
 * 把coda-cli实际的目录存入环境变量
 */
const debugCliPath = cli_api_1.fs.join(cli_api_1.fs.join(__dirname).split('coda-cli')[0], 'coda-cli');
const cliPath = cli_api_1.fs.join(globalNpmRoot, CLIConfig.packageName);
const cliRealRootPath = isDebug ? debugCliPath : cliPath;
process.env.cliRoootPath = cliRealRootPath;
/**
 * 获取 CLI 配置对象
 */
function getCLIConfig() {
    return {
        packageName: commands_json_1.default.packageName,
        wordsLen: commands_json_1.default.wordsLen,
        name: commands_json_1.default.name,
        commands: commands_json_1.default.commands,
        inAnyPath: commands_json_1.default.inAnyPath,
        store: commands_json_1.default.store,
        aiSetting: commands_json_1.default.aiSetting,
    };
}
/**
 * 显示帮助信息
 * @param name CLI 名称
 * @param commands 命令列表
 */
function showHelp(name, commands) {
    let helpList = [];
    commands.forEach(cmd => {
        helpList.push(`${name} ${cmd.command} : ${cmd.description}`);
    });
    helpList.push(name + ' ' + lang_1.Lang.HELP_MESSAGE);
    const helps = `Usage: ${name} [command] \nCommands:\n\t${helpList.join('\n\t')}`;
    cli_core_1.CLI.loading.succeed(lang_1.Lang.CLI_HAS_READY);
    cli_core_1.CLI.log.info(helps);
    process.exit(0);
}
/**
 * 显示Coda-CLI版本
 * @returns
 */
function showVersion() {
    let pkgPath = cli_api_1.fs.join(cliRealRootPath, 'package.json');
    let pkgJSON = cli_api_1.fs.readFile(pkgPath, true);
    cli_core_1.CLI.log.info(pkgJSON.version);
    process.exit(0);
}
/**
 * 检查是否存在相似或匹配的命令
 * @param input 输入的命令
 * @param commands 命令列表
 */
function hasLikeCommand(input, commands) {
    let exsited = false;
    const inputCmd = input.includes('--') ? input.split('--')[0] : input; //判读是否带参数
    let likeList = commands.filter(cmd => {
        if (cmd['command'] === inputCmd) {
            exsited = true;
            return false;
        }
        else {
            let temp = inputCmd.split(' ');
            if (cmd['command'].includes(temp[0])) {
                return true;
            }
            return false;
        }
    });
    return {
        exsited,
        likeList,
    };
}
/**
 * 验证命令合法性
 * @param option 选项/输入内容
 * @param name CLI 名称
 * @param commands 命令列表
 */
function validateCommand(option, name, commands) {
    const { exsited, likeList } = hasLikeCommand(option, commands);
    if (!exsited) {
        const inputCmd = option.includes('--') ? option.split('--')[0] : option; //判读是否带参数
        let formatVal = inputCmd.toLowerCase();
        switch (formatVal) {
            case '--h':
                showHelp(name, commands);
                break;
            case '--v':
                showVersion();
                break;
            default:
                if (likeList.length !== 0) {
                    let likes = [];
                    likeList.forEach(cmd => {
                        likes.push(`${name} ${cmd.command}`);
                    });
                    if (likes.length !== 0) {
                        cli_core_1.CLI.loading.succeed(lang_1.Lang.CLI_HAS_READY);
                        cli_core_1.CLI.log.error(lang_1.Lang.MSG_ERROR, `${lang_1.Lang.NO_COMMAND} "${name} ${option}"`, `${lang_1.Lang.MEAN_SUCH}\n\t${likes.join('\n\t')}`);
                        process.exit();
                    }
                }
                else {
                    cli_core_1.CLI.loading.succeed(lang_1.Lang.CLI_HAS_READY);
                    cli_core_1.CLI.log.error(lang_1.Lang.MSG_ERROR, `${lang_1.Lang.NO_COMMAND} "${name} ${option}".`);
                    process.exit();
                }
                break;
        }
    }
    return {
        exsited,
        likeList,
    };
}
/**
 * 执行命令程序文件
 * @param globalNpmRoot
 * @param cliRealRootPath
 * @param executeEntry
 */
function executeProgram(globalNpmRoot, cliRealRootPath, executeEntry) {
    let programPath = isDebug
        ? cli_api_1.fs.join(cliRealRootPath, 'dist', executeEntry) //调试模式访问dist目录下的路径
        : cli_api_1.fs.join(cliRealRootPath, executeEntry); //生产环境访问的路径
    let child = (0, child_process_1.fork)(programPath, [globalNpmRoot], {
        silent: false,
    });
    child.on('error', (error) => {
        console.clear();
        cli_core_1.CLI.log.error(error.message, error.stack);
        autoUpdate();
    });
    child.on('exit', (code) => {
        if (code === 0) {
            autoUpdate();
        }
    });
}
/**
 * 运行命令
 * @param currArgs
 * @param name
 * @param commands
 */
function runCommand(input, name, commands) {
    let cmdOptions = input.join(' '); //实际命令（不带参数）
    let executeEntry = `${cli_api_1.fs.join('generator', input.join('-'), 'index.js')}`; //命令对应的执行文件路径
    const { exsited } = validateCommand(cmdOptions, name, commands);
    if (exsited) {
        cli_core_1.CLI.loading.succeed(lang_1.Lang.CLI_VOLIDATE_CMD_SUCCESS);
        executeProgram(globalNpmRoot, cliRealRootPath, executeEntry);
    }
    else {
        cli_core_1.CLI.loading.succeed(lang_1.Lang.CLI_HAS_READY);
        cli_core_1.CLI.log.error(lang_1.Lang.MSG_ERROR, `${lang_1.Lang.NO_COMMAND} "${name} ${input.join(' ')}"`);
        process.exit();
    }
}
/**
 * 获取命令参数（多单词命令的参数）
 * @param input
 */
function getCommandArgs(input) {
    const cmdArgs = {}; //获取命令参数
    input.map((item, index) => {
        if (item.includes('--')) {
            const temp = item.split('--')[1].split('=');
            cmdArgs[temp[0]] = temp[1];
        }
    });
    process.env.CODA_CMD_ARGS = JSON.stringify(cmdArgs); //命令参数存入环境变量
}
/**
 * 检查并自动更新 CLI 或相关依赖
 */
async function autoUpdate() {
    let pkgPath = cli_api_1.fs.join(cliRealRootPath, 'package.json'); // 找到 CLI 自身的 PKG，真实位置在 NPM 全局安装目录下
    cli_core_1.CLI.loading.start(lang_1.Lang.CORE_CHECKING_UPDATE);
    let pkgJSON = cli_api_1.fs.readFile(pkgPath, true);
    let storeUrl = CLIConfig.store;
    let url = cli_api_1.fs.join(storeUrl, CLIConfig.packageName);
    let cliVersion = await cli_api_1.packages.checkVersion(url, pkgJSON.version);
    if (JSON.stringify(cliVersion) === '{}') {
        cli_core_1.CLI.loading.info(lang_1.Lang.CORE_LATEST_VERSION); //CLI版本最新无需操作
    }
    else {
        cli_core_1.CLI.loading.info(lang_1.Lang.CORE_UPDATE_READY); // 升级 CLI 需要切换目录到 NPM 全局安装目录
        cli_core_1.CLI.log.printObject(cliVersion);
        const task = 'npm install -g code-cli --loglevel info --timing';
        if (process.platform === 'win32') {
            cli_core_1.ChildProcess.runCmdLive(task, globalNpmRoot);
        }
        else {
            cli_core_1.CLI.log.warn(lang_1.Lang.CORE_LINUX_INPUT_ROOT_USER_PASSWORD);
            cli_core_1.ChildProcess.runCmdLive(`sudo ${task}`, globalNpmRoot);
        }
    }
}
/**
 * 引导和执行命令的主逻辑
 */
async function guideCommand() {
    const { wordsLen, name, commands, inAnyPath } = getCLIConfig();
    const currArgs = process.argv.slice(2); //获取实际输入内容（coda本身除外的单词）
    if (currArgs.length === 0) {
        showVersion(); //输入coda 显示版本
    }
    else if (currArgs.length === 1) {
        if (currArgs[0] === '--h') {
            showHelp(name, commands); //输入 coda --h 显示命令使用帮助信息
        }
        else if (currArgs[0] === '--v') {
            showVersion(); //输入 coda --v 显示版本
        }
        else {
            runCommand(currArgs, name, commands);
        }
    }
    else {
        if (currArgs.length <= wordsLen) {
            getCommandArgs(currArgs);
            runCommand(currArgs, name, commands);
        }
        else {
            cli_core_1.CLI.loading.succeed(lang_1.Lang.CLI_HAS_READY);
            cli_core_1.CLI.log.error(lang_1.Lang.MSG_ERROR, lang_1.Lang.COMMAND_LENGTH_TOO_LONG);
            process.exit();
        }
    }
}
guideCommand();
